import { Preferences } from "../../profile/objects/preferences";
import { Column } from "../objects/column";
import { ListPreferenceResult, setListPreference } from "../../utils/list/utils/setListPreference";
import { MARGIN_COLUMN, MINI_NETWORK_MARGIN_MODULE } from "../constant/miniNetworkConstant";

export const setMarginPreference = (new_preferences: Preferences[], state_columns: Column[]): ListPreferenceResult =>
    setListPreference(new_preferences, state_columns, {
        module: MINI_NETWORK_MARGIN_MODULE,
        default_columns: MARGIN_COLUMN,
        default_order_by: '',
        default_order: 'asc',
    });
